import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useEffect, useState } from 'react';
import { BDSMForm } from '../../../../../components/form/BDSMForm';
import * as Yup from 'yup';
import { getGroupsAndBudgetConfigs, saveGroupsAndBudgetConfigs } from '../UserSettingsService';

export const GroupsAndBudgetBlock = () => {

    const { t } = useTranslation('settings');
    const alert = useAlert();
    const [initValue, setInitValue] = useState({
        smallKidsCode: 0,
        smallKidsDayPrice: 0.0,
        kidsCode: 0,
        kidsDayPrice: 0.0,
        preschoolersCode: 0,
        preschoolersDayPrice: 0.0,
        employeesDayPrice: 0.0,
    });

    const validation = Yup.object().shape({
        smallKidsCode: Yup.number().min(0, t('validations:higherThan') + 0),
        smallKidsDayPrice: Yup.number().required(t('validations:required')).min(0.01, t('validations:minPrice')),
        kidsCode: Yup.number().min(0, t('validations:higherThan') + 0),
        kidsDayPrice: Yup.number().required(t('validations:required')).min(0.01, t('validations:minPrice')),
        preschoolersCode: Yup.number().min(0, t('validations:higherThan') + 0),
        preschoolersDayPrice: Yup.number().required(t('validations:required')).min(0.01, t('validations:minPrice')),
        employeesDayPrice: Yup.number().required(t('validations:required')).min(0.01, t('validations:minPrice')),
    });

    useEffect(() => {
        getGroupsAndBudgetConfigs()
            .then((response) => setInitValue(response.data))
            .catch(() => alert.error(t('alert:loadingError')));
    }, []);

    const handleSubmit = (form) => {
        saveGroupsAndBudgetConfigs(form)
            .then(() => alert.success(t('alert:saveSuccess')))
            .catch(() => alert.error(t('alert:loadingError')));
    };

    const cancel = () => {
        //     ignore
    };

    const getFormModel = () => {
        return {
            initValues: initValue,
            onSubmit: (form) => handleSubmit(form),
            onCancel: (c) => cancel(c),
            validationSchema: validation,
            fieldNames: [
                'smallKidsCode',
                'smallKidsDayPrice',
                'kidsCode',
                'kidsDayPrice',
                'preschoolersCode',
                'preschoolersDayPrice',
                'employeesDayPrice'],
            className: 'mb-3',
            label: [
                t('groupsAndBudget.smallKidsCode'),
                t('groupsAndBudget.smallKidsDayPrice'),
                t('groupsAndBudget.kidsCode'),
                t('groupsAndBudget.kidsDayPrice'),
                t('groupsAndBudget.preschoolersCode'),
                t('groupsAndBudget.preschoolersDayPrice'),
                t('groupsAndBudget.employeesDayPrice'),
            ],
            types: ['number', 'number', 'number', 'number', 'number', 'number', 'number'],
            selectData: [null, null, null, null, null, null, null],
            inputFieldsClass: '',
            hideCancel: true
        };
    };


    return <BDSMForm form={getFormModel()} />;
};